import { ESuburbanEstimationCategory } from '@cian/valuation-main-filters-widget';

export function getMoreFiltersText(
  isReportStatusDefault: boolean,
  category: ESuburbanEstimationCategory | undefined,
): string {
  if (category === ESuburbanEstimationCategory.HouseSale) {
    return 'Указать все параметры дома';
  }

  if (category === ESuburbanEstimationCategory.LandSale) {
    return 'Указать все параметры участка';
  }

  return isReportStatusDefault ? `Указать все параметры квартиры` : 'Все параметры квартиры';
}
